import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/CloseModal.svg'


const _hoisted_1 = { class: "allFeedback" }
const _hoisted_2 = { class: "allFeedback__header" }
const _hoisted_3 = { class: "allFeedback-title" }
const _hoisted_4 = { class: "allFeedback__body" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.showModalAllFeedback)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeModal')))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('allFeedback')) + " " + _toDisplayString(_ctx.selectedKey) + " " + _toDisplayString(_ctx.$t('reaction')), 1),
              _createElementVNode("img", {
                src: _imports_0,
                alt: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModal')))
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedback, (el, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "feedback"
                }, [
                  _createElementVNode("img", {
                    class: "item-img",
                    src: 
              require(`@/assets/icons/${_ctx.getLabel()[_ctx.commentKey]}Pressed.png`)
            ,
                    alt: ""
                  }, null, 8, _hoisted_5),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(el.value), 1)
                  ])
                ]))
              }), 128)),
              (!_ctx.feedback.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('noFeedback')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}